export default __webpack_public_path__ + "static/media/2232.e367b986.png";